// Transfer state machine states
export var TransferState;
(function (TransferState) {
    TransferState[TransferState["Failed"] = -1] = "Failed";
    TransferState[TransferState["Created"] = 0] = "Created";
    TransferState[TransferState["SourceInitiated"] = 1] = "SourceInitiated";
    TransferState[TransferState["SourceFinalized"] = 2] = "SourceFinalized";
    TransferState[TransferState["InReview"] = 3] = "InReview";
    TransferState[TransferState["Attested"] = 4] = "Attested";
    TransferState[TransferState["Refunded"] = 5] = "Refunded";
    TransferState[TransferState["DestinationInitiated"] = 6] = "DestinationInitiated";
    TransferState[TransferState["DestinationQueued"] = 7] = "DestinationQueued";
    TransferState[TransferState["DestinationFinalized"] = 8] = "DestinationFinalized";
})(TransferState || (TransferState = {}));
export function isSourceInitiated(receipt) {
    return receipt.state === TransferState.SourceInitiated;
}
export function isSourceFinalized(receipt) {
    return receipt.state === TransferState.SourceFinalized;
}
export function isInReview(receipt) {
    return receipt.state === TransferState.InReview;
}
export function isAttested(receipt) {
    return receipt.state === TransferState.Attested;
}
export function isRefunded(receipt) {
    return receipt.state === TransferState.Refunded;
}
export function isRedeemed(receipt) {
    return receipt.state === TransferState.DestinationInitiated;
}
export function isDestinationQueued(receipt) {
    return receipt.state === TransferState.DestinationQueued;
}
export function isCompleted(receipt) {
    return receipt.state === TransferState.DestinationFinalized;
}
export function isFailed(receipt) {
    return receipt.state < 0;
}
//# sourceMappingURL=types.js.map